import '../paedml-modal.tag'
import '../paedml-form-input.tag'

<paedml-modal-edit-fwsettings>
<paedml-modal prefix={opts.prefix} heading={opts.heading} opname={opts.opname} edit={opts.edit}
    selectedrowsfunc={opts.selectedrowsfunc} idcol={opts.idcol} idtextcol={opts.idtextcol} submitfunc={submitHandler}>

    <yield to="fields">
        <div class="paedml-input-group">
            <div class="row">
                <div class="col-sm-12">
                    <paedml-form-input name="firewallType" label="Firewalltyp" ref="firewallType" type="select"
                        values={parent.firewalls} required data-msg="Bitte wählen Sie den Firewalltyp"
                    />
                </div>
            </div>
        </div>
        <div class="paedml-input-group" show={parent.isSophosFirewall() || parent.data.firewallType === 'OCTO'}>
            <div class="row">
                <div class="col-sm-12" show={parent.data.firewallType === 'OCTO'}>
                    <paedml-form-input name="firewallInstanceName" label="Instanzname Ihrer OctoGate"
                        required
                        data-msg="Bitte geben Sie den Instanznamen ein" data-rule-fwinstname
                        data-msg-fwinstname="Bitte geben Sie den Hostnamen Ihrer OctoGate ein (8 Zeichen)." />
                </div>
                <div class="col-sm-12" show={parent.isSophosFirewall()}>
                    <paedml-form-input name="sophosApiUrl" label="Sophos API-URL"
                        required data-msg="Bitte geben Sie die API-URL ein" />
                </div>
                <div class="col-sm-12" show={parent.data.firewallType === 'SOPHOS_XG'}>
                    <paedml-form-input name="sophosXgApiUsername" label="Sophos API-Benutzer" required
                        data-msg="Bitte geben Sie den API-Benutzer ein" />
                </div>
                <div class="col-sm-12" show={parent.isSophosFirewall()}>
                    <paedml-form-input name="sophosApiToken" label="API-Token" required
                        data-msg="Bitte geben Sie den API-Token ein" />
                </div>
            </div>
        </div>
        <div class="paedml-input-group" show={parent.data.firewallType === 'OCTO'}>
            <div class="row">
                <div class="col-sm-12 py-2">
                    <paedml-form-input name="teacherWhitelistAccessEnabled"
                        placeholder="Lehrkräfte dürfen Klassen-Whitelist bearbeiten" type="checkbox" revlut="jaNein" />
                </div>
            </div>
        </div>
    </yield>
</paedml-modal> 
    
    <script>
        import store from '../../store'
        import { client } from '../../util/api-util'
        import * as mapper from '../../mapper'
        import * as R from 'ramda'
        import Masterdata from '../../config/masterdata'
        import API from '../../api'

        this.opname = this.opts.opname
        this.edit = this.opts.edit ? true : false
        this.data = {}
        this.api = this.opts.api
        this.firewalls = []

        this.isSophosFirewall = () => {
            if (!this.data.firewallType) return false;
            return R.startsWith('SOPHOS', this.data.firewallType)
        }

        this.on('dataRequested', () => {
            this.getFirewallSettings()
        })

        this.getFirewallSettings = () => {
            API.fwsettings.get().then(rsp => {
                const [data, status] = rsp
                this.data = data

                this.getFirewalls()
            })
        }

        this.getFirewalls = () => {
            API.fw.get().then(rsp => {
                const [data, status] = rsp
                this.firewalls = data.map(firewall => [firewall.type, firewall.name])
                this.update()

                $('select[name=firewallType]').val(this.data.firewallType)
                $('input[name=firewallInstanceName]').val(this.data.firewallInstanceName)
                $('input[name=sophosApiUrl]').val(this.data.sophosApiUrl)
                $('input[name=sophosApiToken]').val(this.data.sophosApiToken)
                $('input[name=sophosXgApiUsername]').val(this.data.sophosXgApiUsername)
                $('input[name=teacherWhitelistAccessEnabled]').prop('checked', this.data.teacherWhitelistAccessEnabled)
            })
        }

        this.submitHandler = formData => {

            return API.fwsettings.update(R.omit(['ids', 'idTexts'], formData))
                .then(rsp => {
                    const [data, status] = rsp
                    if (status.success) {
                        window.request.relogin()
                        return 'Änderung(en) erfolgreich übernommen'
                    }

                    console.error('error-status', status)
                    console.error('error-data', data)
                    if (data.message) {
                        return Promise.reject(data.message)
                    }
                    return Promise.reject('Änderung(en) konnten nicht übernommen werden!')
                })
        }   
    </script>
</paedml-modal-edit-fwsettings>
